
  import { Component, Vue } from 'vue-property-decorator'
  import BackNav from '@/components/BackNav/index.vue'
  import { editMicroStoreInfo } from '@/api/store'
  import { Debounce } from '@/core/decorator'
  import { phone } from '@/core/regexp'
  import { Getter } from 'vuex-class'
  
  @Component({
    name: 'EditPhone',
  })
  export default class EditPhone extends Vue {
    @Getter companyId!: string
    storePhone = ''

    phone = phone

    isShake = false
    errShakeClass = 'animate__animated animate__headShake'
    isExceed = false
    errorMsg = ''

    created() {
      // const currentStore = JSON.parse(sessionStorage.getItem('currentStore') || '{}')
      // this.storeId = currentStore.id
      // 从路由参数获取初始值
      this.storePhone = (this.$route.query.receiveMobile as string) || ''
    }

    validateMobile() {
      if (!this.storePhone.trim()) {
        this.isShake = true
        this.isExceed = true
        this.errorMsg = '请输入微店联系电话'
        setTimeout(() => {
          this.isShake = false
          this.isExceed = false
        }, 1000)
        return false
      }
      if (!this.phone.test(this.storePhone)) {
        this.isShake = true
        this.isExceed = true
        this.errorMsg = '请输入正确格式的手机号码'
        setTimeout(() => {
          this.isShake = false
          this.isExceed = false
        }, 1000)
        return false
      }
      this.errorMsg = ''
      return true
    }

    @Debounce(500)
    async onSave() {
      if (!this.validateMobile()) {
        return
      }

      try {
        const res = await editMicroStoreInfo({
            storeId: this.companyId,
            receiveMobile: this.storePhone
        })
        if (res.code === '000000') {
            this.$toast.success('保存成功')
            setTimeout(() => {
                this.$router.back()
            }, 1000)
        } else {
            this.$toast.fail(res.msg || '保存失败')
        }
      } catch (e) {
        console.error(e)
        this.$toast.fail('保存失败')
      }
    }
  }
  